import { AxiosRequestConfigMethods } from "@/api/types";
import { brandUrl, fetchFromBrandedUrl } from "@/api/utils";
import { EnvironmentVariables } from "@/modules/common/types";
import {
  ContractsHistoryResponse,
  TenantContractResponse,
} from "../../dtos/tenants";

export const getCurrentTenantContract = async (data: {
  propertyUid: string;
}) => {
  const apiUrl = brandUrl(
    `${EnvironmentVariables.CONTRACTS_API_URL}/properties/${data.propertyUid}/tenant-contracts/latest`
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.GET,
    },
  }) as Promise<{
    data: TenantContractResponse;
  }>;
};

export const getTenantsHistory = async (data: { propertyUid: string }) => {
  const apiUrl = brandUrl(
    `${EnvironmentVariables.CONTRACTS_API_URL}/properties/${data.propertyUid}/tenant-contracts/history`
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.GET,
    },
  }) as Promise<{
    data: ContractsHistoryResponse;
  }>;
};

export const downloadTenantContract = async ({
  contractUid,
}: {
  contractUid: string;
}) => {
  const apiUrl = brandUrl(
    `${EnvironmentVariables.CONTRACTS_API_URL}/contracts/${contractUid}/download-generated-contract`
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.GET,
      responseType: "json",
    },
  }) as Promise<{
    data: { url: string };
    headers: Record<string, string>;
  }>;
};
